import { STAFF_ROUTE, PERFORMERS_ROUTE } from './routes';

export type StaffSection = 'workers' | 'performers';

export const getStaffSection = (pathname: string): StaffSection => (
    pathname === PERFORMERS_ROUTE.path || pathname.startsWith(`${PERFORMERS_ROUTE.path}/`)
        ? 'performers' : 'workers'
);

export const getStaffListPath = (section: StaffSection, archived = false): string => (
    (section === 'performers' ? PERFORMERS_ROUTE.path : STAFF_ROUTE.path) + (archived ? '/archive' : '')
);

export const getStaffReturnPath = (search: string, section: StaffSection): string => {
    const value = new URLSearchParams(search).get('returnTo') || '';
    const pathname = value.split('?')[0];
    return [getStaffListPath(section), getStaffListPath(section, true)].includes(pathname)
        && !value.includes('#') ? value : getStaffListPath(section);
};

export const getStaffDetailPath = (userId: number | string, section: StaffSection, search = '', suffix = ''): string => (
    `${getStaffListPath(section)}/${userId}${suffix}${search}`
);

export const isStaffDetailPath = (pathname: string, userId: number): boolean => (
    new RegExp(`^/(staff|performers)/${userId}(/(idm|history|payment-details))?$`).test(pathname)
);

export const withStaffReturnPath = (pathname: string, returnTo: string): string => (
    `${pathname}?${new URLSearchParams({returnTo}).toString()}`
);

export const isTutorStaffItem = (item: {is_tutor?: boolean; roles: string[]}): boolean => (
    item.is_tutor ?? item.roles.some(role => ['репетитор', 'исполнитель', 'tutor'].includes(role.trim().toLowerCase()))
);
